// extracted by mini-css-extract-plugin
export default {"link":"link-CrzwD","controls":"controls-eQu_W","error":"error-e6req"};